import { KTypeParameterBase70dfo08xyjmg as KTypeParameterBase } from '../../KTypeParameterBase.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KTypeParameterImplClass;
function KTypeParameterImpl() {
  if (KTypeParameterImplClass === VOID) {
    class $ extends KTypeParameterBase() {
      constructor(name, upperBounds, variance, isReified, containerFqName) {
        super();
        this.qf_1 = name;
        this.rf_1 = upperBounds;
        this.sf_1 = variance;
        this.tf_1 = isReified;
        this.uf_1 = containerFqName;
      }
      m1() {
        return this.qf_1;
      }
      z1() {
        return this.sf_1;
      }
      y1() {
        return this.uf_1;
      }
    }
    initMetadataForClass($, 'KTypeParameterImpl');
    KTypeParameterImplClass = $;
  }
  return KTypeParameterImplClass;
}
//region block: exports
export {
  KTypeParameterImpl as KTypeParameterImpl2de0szhlrzcmf,
};
//endregion

//# sourceMappingURL=KTypeParameterImpl.mjs.map
